import { render, staticRenderFns } from "./ContentWithSwiper.vue?vue&type=template&id=2e456576"
import script from "./ContentWithSwiper.vue?vue&type=script&lang=ts"
export * from "./ContentWithSwiper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports